module.exports = __webpack_public_path__ + "y.no2.3aec6c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/y.no2.jpg
// module id = J/LG
// module chunks = 0